import { Directive, ElementRef, HostListener } from '@angular/core';
import { CommonServices } from '../Common/CommonServices';

@Directive({
  selector: '[companyTaxNumber]',
  standalone: false
})
export class TaxNumberDirective {
constructor(
    private el: ElementRef,
    private commonServices: CommonServices
  ) {}

  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    const inputChar = String.fromCharCode(event.charCode);
    const currentValue: string = this.el.nativeElement.value || '';
    const newValue = currentValue + inputChar;

    // Allow only alphanumeric and -
    const allowedRegex = /^[a-zA-Z0-9-]$/;
    if (!allowedRegex.test(inputChar)) {
      event.preventDefault();
      this.commonServices.showMessage('error', 'Only letters, numbers, and hyphen allowed', 2);
      return;
    }

    // Restrict to max 10 characters
    if (newValue.length > 10) {
      event.preventDefault();
      return;
    }

    // Hyphen must be at 3rd position only
    if (inputChar === '-') {
      if (currentValue.includes('-')) {
        event.preventDefault();
        this.commonServices.showMessage('error', 'Only one hyphen allowed', 2);
        return;
      }
      if (currentValue.length !== 2) {
        event.preventDefault();
        this.commonServices.showMessage('error', 'Hyphen must be at 3rd character', 2);
        return;
      }
    }

    // Block hyphen at any other position
    if (currentValue.length === 2 && inputChar !== '-') {
      event.preventDefault();
      this.commonServices.showMessage('error', 'Hyphen required at 3rd character', 2);
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const pastedText = event.clipboardData?.getData('text') || '';
    const fullFormatRegex = /^[A-Za-z0-9]{2}-[A-Za-z0-9]{7}$/;

    if (!fullFormatRegex.test(pastedText)) {
      event.preventDefault();
      this.commonServices.showMessage('error', 'Paste value must match XX-XXXXXXX format', 2);
    }
  }
}
